/* ========================================
   CARMATSCULTURE Beach Sections JavaScript
   Place this in your theme's assets folder
   ======================================== */

(function() {
  'use strict';

  // ========== VIDEO MODAL ==========
  function initVideoModal() {
    console.log('Initializing video modal...');
    
    // Select all video trigger buttons
    const videoButtons = document.querySelectorAll('[data-video-modal], .beach-video-showcase__thumbnail, .beach-video-trigger');
    console.log('Found video buttons:', videoButtons.length);
    
    if (videoButtons.length === 0) {
      console.warn('No video buttons found');
      return;
    }
    
    let videoModal = document.getElementById('videoModal');
    
    // Create modal if it doesn't exist
    if (!videoModal) {
      console.log('Creating video modal...');
      videoModal = createVideoModal();
      document.body.appendChild(videoModal);
    }
    
    const closeButton = videoModal.querySelector('.beach-video-modal__close');
    const overlay = videoModal.querySelector('.beach-video-modal__overlay');
    const videoContainer = videoModal.querySelector('.beach-video-modal__video');
    
    function openModal(videoUrl, isShopifyVideo = false) {
      console.log('Opening modal with URL:', videoUrl, 'Shopify video:', isShopifyVideo);
      videoModal.style.display = 'block';
      document.body.style.overflow = 'hidden';
      
      // Clear previous content
      videoContainer.innerHTML = '';
      
      if (isShopifyVideo) {
        // Shopify-hosted video (MP4, etc.)
        const video = document.createElement('video');
        video.controls = true;
        video.autoplay = true;
        video.style.width = '100%';
        video.style.height = 'auto';
        video.style.maxHeight = '80vh';
        video.src = videoUrl;
        videoContainer.appendChild(video);
      } else {
        // YouTube/Vimeo embed
        const iframe = document.createElement('iframe');
        iframe.style.width = '100%';
        iframe.style.height = '80vh';
        iframe.style.border = 'none';
        iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
        iframe.allowFullscreen = true;
        
        // Add autoplay parameter
        const separator = videoUrl.includes('?') ? '&' : '?';
        iframe.src = videoUrl + separator + 'autoplay=1';
        videoContainer.appendChild(iframe);
      }
    }
    
    function closeModal() {
      console.log('Closing modal');
      videoModal.style.display = 'none';
      document.body.style.overflow = '';
      
      // Clear video content to stop playback
      videoContainer.innerHTML = '';
    }
    
    // Add click handlers to all video buttons
    videoButtons.forEach((button, index) => {
      console.log('Adding click handler to button', index, button);
      
      button.addEventListener('click', function(e) {
        console.log('Button clicked:', this);
        e.preventDefault();
        e.stopPropagation();
        
        const videoUrl = this.getAttribute('data-video-url') || this.getAttribute('data-video-modal');
        const isShopifyVideo = this.getAttribute('data-shopify-video') === 'true';
        
        console.log('Video URL:', videoUrl, 'Is Shopify:', isShopifyVideo);
        
        if (videoUrl) {
          openModal(videoUrl, isShopifyVideo);
        } else {
          console.error('No video URL found on button');
        }
      });
    });
    
    if (closeButton) {
      closeButton.addEventListener('click', closeModal);
    }
    
    if (overlay) {
      overlay.addEventListener('click', closeModal);
    }
    
    // Close on ESC key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && videoModal.style.display === 'block') {
        closeModal();
      }
    });
    
    console.log('Video modal initialized successfully');
  }

  function createVideoModal() {
    const modal = document.createElement('div');
    modal.id = 'videoModal';
    modal.className = 'beach-video-modal';
    modal.style.cssText = `
      display: none;
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 10000;
      animation: fadeIn 0.3s ease;
    `;
    
    modal.innerHTML = `
      <div class="beach-video-modal__overlay" style="
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.95);
        backdrop-filter: blur(4px);
      "></div>
      <div class="beach-video-modal__content" style="
        position: relative;
        width: 90%;
        max-width: 1200px;
        margin: 5vh auto;
        z-index: 10001;
      ">
        <button class="beach-video-modal__close" style="
          position: absolute;
          top: -50px;
          right: 0;
          background: rgba(255, 255, 255, 0.95);
          border: 2px solid rgba(255, 255, 255, 0.3);
          width: 44px;
          height: 44px;
          border-radius: 50%;
          cursor: pointer;
          font-size: 28px;
          line-height: 1;
          color: #333;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.3s ease;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
        " onmouseover="this.style.background='#fff'; this.style.transform='scale(1.1)';" onmouseout="this.style.background='rgba(255, 255, 255, 0.95)'; this.style.transform='scale(1)';">×</button>
        <div class="beach-video-modal__frame" style="
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          padding: 8px;
          border-radius: 16px;
          box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
        ">
          <div class="beach-video-modal__video" style="
            border-radius: 12px;
            overflow: hidden;
            background: #000;
            box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.1);
          "></div>
        </div>
      </div>
    `;
    
    return modal;
  }

  // ========== FAQ ACCORDION ==========
  function initFAQ() {
    const faqQuestions = document.querySelectorAll('.beach-faq__question');
    
    faqQuestions.forEach(question => {
      question.addEventListener('click', function() {
        const item = this.closest('.beach-faq__item');
        const isActive = item.classList.contains('active');
        
        // Close all other items
        document.querySelectorAll('.beach-faq__item').forEach(otherItem => {
          if (otherItem !== item) {
            otherItem.classList.remove('active');
          }
        });
        
        // Toggle current item
        if (isActive) {
          item.classList.remove('active');
        } else {
          item.classList.add('active');
        }
      });
    });
  }

  // ========== CUSTOM LIQUID BUTTON SCROLL ==========
  function initLiquidButtonScroll() {
    // Scroll to liquid button when CTA buttons are clicked
    const ctaButtons = document.querySelectorAll('[data-scroll-to-cta]');
    
    ctaButtons.forEach(button => {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        const liquidButton = document.querySelector('.ultimateCar[data-open-target]');
        
        if (liquidButton) {
          liquidButton.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
        }
      });
    });
  }

  // ========== SMOOTH SCROLL FOR ANCHOR LINKS ==========
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function(e) {
        const href = this.getAttribute('href');
        if (href === '#') return;
        
        const target = document.querySelector(href);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      });
    });
  }

  // ========== TESTIMONIALS CAROUSEL ==========
  function initTestimonialsCarousel() {
    console.log('Initializing testimonials carousel...');
    
    const carousels = document.querySelectorAll('.beach-testimonials__carousel');
    
    carousels.forEach(carousel => {
      const track = carousel.querySelector('.beach-testimonials__track');
      const slides = Array.from(track.children);
      const prevBtn = carousel.parentElement.querySelector('.beach-testimonials__nav--prev');
      const nextBtn = carousel.parentElement.querySelector('.beach-testimonials__nav--next');
      const dotsContainer = carousel.parentElement.parentElement.querySelector('.beach-testimonials__dots');
      
      if (!track || slides.length === 0) return;
      
      let currentIndex = 0;
      const totalSlides = slides.length;
      
      // Get slides per view based on screen width
      function getSlidesPerView() {
        const width = window.innerWidth;
        if (width >= 1024) return 3; // Desktop: 3 cards
        if (width >= 768) return 2;  // Tablet: 2 cards
        return 1;                     // Mobile: 1 card
      }
      
      // Calculate max index based on slides per view
      function getMaxIndex() {
        const slidesPerView = getSlidesPerView();
        return Math.max(0, totalSlides - slidesPerView);
      }
      
      // Create dots
      slides.forEach((_, index) => {
        const dot = document.createElement('button');
        dot.classList.add('beach-testimonials__dot');
        if (index === 0) dot.classList.add('active');
        dot.setAttribute('aria-label', `Go to testimonial ${index + 1}`);
        dot.addEventListener('click', () => goToSlide(index));
        dotsContainer.appendChild(dot);
      });
      
      const dots = Array.from(dotsContainer.children);
      
      // Update carousel position
      function updateCarousel() {
        const slidesPerView = getSlidesPerView();
        const slideWidth = 100 / slidesPerView;
        const offset = -currentIndex * slideWidth;
        track.style.transform = `translateX(${offset}%)`;
        
        // Update dots
        dots.forEach((dot, index) => {
          dot.classList.toggle('active', index === currentIndex);
        });
      }
      
      // Go to specific slide
      function goToSlide(index) {
        currentIndex = index;
        updateCarousel();
      }
      
      // Next slide
      function nextSlide() {
        const maxIndex = getMaxIndex();
        if (currentIndex < maxIndex) {
          currentIndex++;
        } else {
          currentIndex = 0; // Loop back to start
        }
        updateCarousel();
      }
      
      // Previous slide
      function prevSlide() {
        const maxIndex = getMaxIndex();
        if (currentIndex > 0) {
          currentIndex--;
        } else {
          currentIndex = maxIndex; // Loop to end
        }
        updateCarousel();
      }
      
      // Event listeners
      if (nextBtn) nextBtn.addEventListener('click', nextSlide);
      if (prevBtn) prevBtn.addEventListener('click', prevSlide);
      
      // Auto-play (optional - every 5 seconds)
      let autoplayInterval = setInterval(nextSlide, 5000);
      
      // Pause autoplay on hover
      carousel.addEventListener('mouseenter', () => {
        clearInterval(autoplayInterval);
      });
      
      carousel.addEventListener('mouseleave', () => {
        autoplayInterval = setInterval(nextSlide, 5000);
      });
      
      // Touch/swipe support
      let touchStartX = 0;
      let touchEndX = 0;
      
      carousel.addEventListener('touchstart', (e) => {
        touchStartX = e.changedTouches[0].screenX;
      });
      
      carousel.addEventListener('touchend', (e) => {
        touchEndX = e.changedTouches[0].screenX;
        handleSwipe();
      });
      
      function handleSwipe() {
        const swipeThreshold = 50;
        const diff = touchStartX - touchEndX;
        
        if (Math.abs(diff) > swipeThreshold) {
          if (diff > 0) {
            nextSlide();
          } else {
            prevSlide();
          }
        }
      }
      
      // Keyboard navigation
      carousel.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') prevSlide();
        if (e.key === 'ArrowRight') nextSlide();
      });
      
      // Handle window resize
      let resizeTimeout;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
          // Reset to first slide on resize to avoid layout issues
          currentIndex = 0;
          updateCarousel();
        }, 250);
      });
      
      console.log(`Carousel initialized with ${totalSlides} slides`);
    });
  }

  // ========== INITIALIZE ALL ==========
  function init() {
    console.log('Initializing beach sections...');
    initVideoModal();
    initFAQ();
    initLiquidButtonScroll();
    initSmoothScroll();
    initTestimonialsCarousel();
    console.log('Beach sections initialized');
  }

  // Run on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-initialize on Shopify section render (for theme editor)
  document.addEventListener('shopify:section:load', function() {
    console.log('Shopify section loaded, re-initializing...');
    init();
  });

})();
